import React, { useState, useMemo } from "react";
import CrosstabModal from "../DashboardBuilder/CrosstabModal"; // import your modal
import "../styles/SidebarDashboard.css";
import { useContext } from "react";
import FetchingFreq from "../../contexts/FetchingFreq";

export default function Sidebar({
  dataGroup,
  selectedQuestionKey,
  setSelectedQuestionKey,
  handleAddKPI,
  handleAddFilter,
  handleAddGlobalFilter,
  handleGenerateCrosstab,   // pass this from DashboardBuilder
  globalFilters = [],
  selectedTab,
  selectedVariable,
  crosstabDisplayData,
  setCrosstabDisplayData

}) {
  const { handleTitleClick } = useContext(FetchingFreq);
  const [searchTerm, setSearchTerm] = useState("");
  const [multiSelected, setMultiSelected] = useState([]);
  const sortedEntries = Object.entries(dataGroup || {});
  const [showCrosstabModal, setShowCrosstabModal] = useState(false);

  const filteredEntries = useMemo(() => {
    return sortedEntries.filter(([key, entry]) =>
      (entry.title || key).toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm, sortedEntries]);

  const handleOpenCrosstabModal = () => {
    if (sortedEntries.length < 2) {
      alert("You need at least two variables to create a crosstab.");
      return;
    }
    setShowCrosstabModal(true);
  };
  const handleLocalFilterClick = () => {
    if (!selectedQuestionKey) {
      alert("Please select a variable first.");
      return;
    }

    // Check if already in global filters
    if (globalFilters.some(f => f.variable_name === selectedQuestionKey)) {
      alert("❌ This variable is already added as a Global Filter.");
      return;
    }

    // Check if already in local filters
    if (selectedTab?.filters?.some(f => f.variableName === selectedQuestionKey)) {
      alert("⚠️ This variable is already added as a Local Filter in this tab.");
      return;
    }

    handleAddFilter(); // call the prop from DashboardBuilder
  };


  return (
    <div className="sidebar">
      <div className="sidebar-buttons">
        <button
          onClick={() => {
            if (multiSelected.length === 0) {
              alert("Please select at least one variable.");
              return;
            }
            handleAddKPI(multiSelected);
            setMultiSelected([]);
            setSelectedQuestionKey("");
          }}
        >
          ➕ Add KPI ({multiSelected.length})
        </button>

        <button onClick={handleLocalFilterClick}>🎯 Add Local Filter</button>

        <button onClick={handleOpenCrosstabModal}>📊 Add Crosstab</button>
      </div>

      {showCrosstabModal && (
        <CrosstabModal
          selectedVars={sortedEntries.map(([k]) => k)}
          onClose={() => setShowCrosstabModal(false)}
          onGenerate={(rowVar, colVar) => {
            // handleGenerateCrosstab(rowVar, colVar);
            setShowCrosstabModal(false);
          }}
          crosstabDisplayData={crosstabDisplayData}
          setCrosstabDisplayData={setCrosstabDisplayData}
        />
      )}

      {/* Search Box */}
      <input
        type="text"
        placeholder="Search variables..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ width: "100%", padding: "6px 8px", marginBottom: 8, borderRadius: 6, border: "1px solid #cbd5e1" }}
      />

      {/* Selected Variable info */}
      {selectedVariable && (
        <div style={{ marginTop: 10, marginBottom: 10, padding: "8px 10px", background: "#f1f5f9", borderRadius: 6, border: "1px solid #e2e8f0", fontSize: 13, color: "#475569" }}>
          <strong>Selected Variable:</strong> {selectedVariable.Qtitle || selectedVariable.title} <br />
          <strong>Question Type:</strong> {selectedVariable.questionType || selectedVariable.type}
        </div>
      )}

      <div className="variable-section">
        {filteredEntries.length > 0 ? (
          filteredEntries.map(([key, entry]) => {
            const disabled = selectedTab?.filters?.some(f => f.variableName === key);
            return (
              <div
                key={key}
                className={`variable-item ${multiSelected.includes(key) ? "multi-selected" : ""} ${selectedQuestionKey === key ? "selected" : ""} ${disabled ? "disabled-variable" : ""}`}
                onClick={() => {
                  if (disabled) return;
                  if (multiSelected.includes(key)) {
                    setMultiSelected(multiSelected.filter((i) => i !== key));
                  } else {
                    setMultiSelected([...multiSelected, key]);
                  }
                  setSelectedQuestionKey(key);
                  handleTitleClick(key)

                }}
                title={disabled ? "Already added as Local Filter" : entry.title || key}
              >
                {entry.title || key}
              </div>
            );
          })
        ) : (
          <p className="no-data">No variables found</p>
        )}
      </div>
    </div>
  );
}
